module.exports = __webpack_public_path__ + "static/media/b32@2x.33770c99.png";